import { ComponentsOverrides, ComponentsProps, Theme, alpha, menuItemClasses } from '@mui/material';

export const MuiMenu: {
    styleOverrides: ComponentsOverrides<Theme>['MuiMenu'];
    defaultProps?: ComponentsProps['MuiMenu'];
} = {
    styleOverrides: {
        root: ({ theme }) => ({
            '& .MuiMenu-list': {
                '& .MuiDivider-root': {
                    marginTop: '4px',
                    marginBottom: '4px',
                    borderColor: theme.palette.grey[200],
                },
            },
        }),
        list: {
            padding: '4px 0',
        },
    },
    defaultProps: {
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        },
        transformOrigin: {
            vertical: 'top',
            horizontal: 'right',
        },
    },
};

export const MuiMenuItem: {
    styleOverrides: ComponentsOverrides<Theme>['MuiMenuItem'];
    defaultProps?: ComponentsProps['MuiMenuItem'];
} = {
    styleOverrides: {
        root: ({ theme }) => ({
            minHeight: theme.spacing(6),
            // Override themes styling for larger screens (up('md'))
            [theme.breakpoints.up('sm')]: {
                minHeight: theme.spacing(6),
            },
            // Styles following Mui - see https://github.com/mui/material-ui/blob/master/packages/mui-material/src/MenuItem/MenuItem.js
            [`&.${menuItemClasses.selected}`]: {
                backgroundColor: alpha(theme.palette.common.black, theme.palette.action.selectedOpacity),
                [`&.${menuItemClasses.focusVisible}`]: {
                    backgroundColor: alpha(
                        theme.palette.common.black,
                        theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity
                    ),
                },
            },
            [`&.${menuItemClasses.selected}:hover`]: {
                backgroundColor: alpha(
                    theme.palette.common.black,
                    theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity
                ),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: alpha(theme.palette.common.black, theme.palette.action.selectedOpacity),
                },
            },
        }),
    },
};
